import { inject, Injectable } from '@angular/core';

import { shareReplay } from 'rxjs/operators';

import { filterDefined } from '@core/common-legacy';
import { JobsWrapperDataService } from '@core/offers-data';

@Injectable({ providedIn: 'root' })
export class ActiveJobsDataService {
  private readonly jobsWrapperDataService = inject(JobsWrapperDataService);

  public readonly data$ = this.jobsWrapperDataService
    .getActiveJobItems$()
    .pipe(filterDefined, shareReplay({ bufferSize: 1, refCount: true }));
}
